module.exports = __webpack_public_path__ + "img/award-02.110ce264.svg";